<template>
    <main id="people-types-new-or-edit" class="wrapper-content w-100">
      <LmComponentLoading v-if="isLoading" fixed />

      <h1 v-if="!isOnEditMode">{{ $t('people_types_generator')}}</h1>
      <h1 v-if="isOnEditMode">{{ $t('people_types_edit')}}</h1>
      <LmForm ref="lmFormRef" >
        <LmTextInput
          class="col-12 px-0"
          :v="$v.formData.typeName"
          v-model="formData.typeName"
          :label="$t('people_type_name')"
          :placeholder="$t('people_type_name_placeholder')"
        />
        <LmTextInput
          class="col-12 px-0"
          :v="$v.formData.typeAlias"
          v-model="formData.typeAlias"
          :label="$t('people_type_alias')"
          :placeholder="$t('people_type_alias_placeholder')"
        />
        <LmTextArea
          class="col-12 px-0"
          v-model="formData.typeDescription"
          :v="$v.formData.typeDescription"
          :label="$t('people_type_description')"
          :placeholder="$t('people_type_description_placeholder')"
        />
        <LmTreeSelect
          class="col-3 px-0"
          v-model="formData.idType"
          :v="$v.formData.idType"
          :help="$t('people_idtype_help')"
          :label="$t('people_idtype')"
          pathToGetOptions="/customer/peopleidtypes"
          multiple
        />
      </LmForm>
      <hr class="w-100"/>
      <!-- FormBuilderUi -->
      <div id="lm-form-builder-ui" class="wrapper-content w-100 px-0 mt-3">
        <div class="row position-relative">
          <div class="col-12">
            <b-form-group :label="$t('view_modes')">
              <b-form-radio-group buttons button-variant="primary" v-model="modes.selected">
                <b-form-radio
                  name="viewMode"
                  value="edit"
                  @change="modes.editView = $event === 'edit'"
                >
                  <font-awesome-icon class="mr-1" icon="wrench" />
                  {{ $t('edit_mode') }}
                </b-form-radio>
                <b-form-radio
                  name="viewMode"
                  value="preview"
                  @change="modes.editView = $event === 'edit'"
                >
                  <font-awesome-icon class="mr-1" icon="eye" />
                  {{ $t('preview_mode') }}
                </b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </div>
          <div class="col-12">
            <h3>Formulario de ingreso de datos</h3>
            <strong>Los siguientes campos ya estarán incluidos:</strong>
            <p class="mt-2">• Nombre / Razón Social</p>
            <p>• Tipo de Identificación e Identificación</p>
            <p>• Email</p>
            <b-row>
              <LmSuperPowerSelectV2
                class="col-12 col-md-6 mt-2"
                :options="peopleTypesOptionsForDuplicate"
                @input="loadFormElements"
                :label="$t('import_form_components_from_another_people_type')"
              />
            </b-row>
            <div class="row" v-if="componentsOptions.content.length">
              <div class="col-12 col-md-6 px-0" v-show="modes.editView">
                <LmForm ref="lmFormBuilderRef" id="peopleFormElements">
                  <draggable
                    class="col-12"
                    v-model="form.formElements"
                    @start="drag=true"
                    @end="drag=false"
                    animation="150"
                    handle=".handle"
                    >
                    <div v-for="(formElement, index) in form.formElements" :key="formElement.id" class="mt-4">
                      <header
                        class="d-flex justify-content-between align-items-center bg-primary text-white px-3 handle shadow rounded-lg"
                        :class="{'bg-info': !shouldCreatePortal(form.formElements[index].componentName)}">
                        <font-awesome-icon class="mr-4" icon="arrows-alt" style="width:18px; height:18px;" />
                        <h4 v-b-toggle="`collapse-${index}`" class="flex-grow-1 text-center my-0 py-3 handle">{{title(form.formElements[index])}}</h4>
                        <div v-if="shouldCreatePortal(form.formElements[index].componentName)" class="circle d-flex justify-content-center align-items-center">{{index}}</div>
                        <div class="d-flex align-items-center">
                          <font-awesome-icon v-b-toggle="`collapse-${index}`" class="ml-4 clickable" icon="chevron-down" style="width:16px; height:16px;" />
                          <font-awesome-icon class="ml-4 clickable" icon="trash" @click="removeFormElement(index)" style="width:16px; height:16px;" />
                        </div>
                      </header>
                      <b-collapse
                        accordion="my-accordion"
                        :id="`collapse-${index}`"
                        visible
                        class="p-4 border border-top-0 rounded-lg"
                        >
                        <LmSelect
                          :id="'select-elements-' + index"
                          v-model="form.formElements[index].componentName"
                          :options="componentsOptions"
                          :label="$t('select_elemet_type')"
                          @input="selectorElementForm($event, index)"
                        />
                        <component
                          :index="index"
                          :is="whatComponentBuilderUse(form.formElements[index].componentName)"
                          :id="form.formElements[index].formObjectToSendToServerProperty || form.formElements[index].id"
                          :componentData="form.formElements[index]"
                          :optionsChildOf="buildOptionsChildOf(form.formElements[index].formObjectToSendToServerProperty)"
                          :leftValueToCompareOptions="leftValueToCompareOptions(form.formElements[index])"
                          :visibilityDependOnConditions="form.formElements[index].visibilityDependOnConditions"
                          :optionsSameAsValidation="{content: buildSameAsOptions(form.formElements)}"
                          :validationsData="getValidation(form.formElements[index].formObjectToSendToServerProperty)"
                          :options="lmSuperPowerSelectV2BuilderUiOptions"
                          :isOnEditMode="isOnEditMode"
                          @input="inputHandler($event, index)"
                          @validations-changes="validationsChangesHandler"
                        />
                      </b-collapse>
                    </div>
                  </draggable>
                  <div class="col-12">
                    <LmButton
                      id="add-field-button"
                      class="mt-4"
                      type="button"
                      lmButtonRootWrapperClass="d-inline-block"
                      lmButtonWrapperClass="col"
                      @click.native="addFormElement(form.formElements.length)"
                      value="Agregar campo adicional"
                    />
                  </div>
                </LmForm>
              </div>
              <!-- Preview del formbuilder que se generará -->
              <div class="col-12 mt-4" :class="{ 'col-md-6': modes.editView }">
                <LmFormBuilder
                  class="px-0"
                  :getComponents="form"
                  :isOnPreviewMode="modes.editView"
                  @openEditFormElement="openEditFormElement"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Action Buttons -->
      <hr class="w-100">
      <div class="d-flex wrapper-content pl-0">
        <LmButton
          class="col-auto pl-0"
          type="cancel"
          :value="$t('cancel')"
          buttonClass="btn-secondary"
          @click="onCancel()"
        />
        <LmButton
          class="col-auto"
          type="button"
          :value="$t('save')"
          buttonClass="btn-primary"
          @click="onSubmit()"
        />
        <LmButton
          v-if="isOnEditMode && !formData.published"
          class="col-auto"
          type="button"
          :value="$t('save_and_publish')"
          buttonClass="btn-info"
          :requireConfirmation="true"
          :confirmationTitle="$t('people_publish_confirmation_title')"
          :confirmationMessage="$t('people_publish_confirmation_message')"
          @click="onPublish()"
        />
        <LmButton
          v-if="isOnEditMode && formData.published"
          class="col-auto"
          type="button"
          value="Despublicar"
          buttonClass="btn-warning"
          :requireConfirmation="true"
          :confirmationTitle="$t('people_defuse_confirmation_title')"
          :confirmationMessage="$t('people_defuse_confirmation_message')"
          @click="onUnpublish()"
        />
        <LmButton
          v-if="isOnEditMode"
          class="col-auto"
          type="button"
          :value="$t('delete')"
          buttonClass="btn-danger"
          action="delete"
          @click="onDelete()"
        />
      </div>
    </main>
</template>

<script>
// Components
import LmButton from '@/components/form/elements/LmButton'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmTextArea from '@/components/form/elements/LmTextArea'
import LmEmailInput from '@/components/form/elements/LmEmailInput'
import LmRadio from '@/components/form/elements/LmRadio'
import LmCheckbox from '@/components/form/elements/LmCheckbox'
import LmSelect from '@/components/form/elements/LmSelect'
import LmForm from '@/components/form/LmForm'
import LmTreeSelect from '@/components/form/elements/LmTreeSelect'
import LmSuperPowerSelectV2 from '@/components/form/elements/LmSuperPowerSelectV2'

// Form Builder
import LmTextNumberEditorTextAreaPasswordBuilderUi from '@/components/lmFormBuilderUi/LmTextNumberEditorTextAreaPasswordBuilderUi'
import LmEmailInputBuilderUi from '@/components/lmFormBuilderUi/LmEmailInputBuilderUi'
import LmFormSubtitlesBuilderUi from '@/components/lmFormBuilderUi/LmFormSubtitlesBuilderUi'
import LmFormEmptySpaceBuilderUi from '@/components/lmFormBuilderUi/LmFormEmptySpaceBuilderUi'
import LmFormSeparatorBuilderUi from '@/components/lmFormBuilderUi/LmFormSeparatorBuilderUi'
import LmSelectBuilderUi from '@/components/lmFormBuilderUi/LmSelectBuilderUi'
import LmSuperPowerSelectV2BuilderUi from '@/components/lmFormBuilderUi/LmSuperPowerSelectV2BuilderUi'
import LmButtonBuilderUi from '@/components/lmFormBuilderUi/LmButtonBuilderUi'
import LmDateBuilderUi from '@/components/lmFormBuilderUi/LmDateBuilderUi'
import LmDateTimeBuilderUi from '@/components/lmFormBuilderUi/LmDateTimeBuilderUi'
import LmLeaFletMapBuilderUi from '@/components/lmFormBuilderUi/LmLeaFletMapBuilderUi'
import LmHtmlContentBuilderUi from '@/components/lmFormBuilderUi/LmHtmlContentBuilderUi'
import LmFormPortalBuilderUi from '@/components/lmFormBuilderUi/LmFormPortalBuilderUi'
import LmColorPickerBuilderUi from '@/components/lmFormBuilderUi/LmColorPickerBuilderUi'
import LmCommentBuilderUi from '@/components/lmFormBuilderUi/LmCommentBuilderUi'
import LmRepeatFieldsBuilderUi from '@/components/lmFormBuilderUi/LmRepeatFieldsBuilderUi'
import LmCheckboxBuilderUi from '@/components/lmFormBuilderUi/LmCheckboxBuilderUi'
import LmUploadFilesBuilderUi from '@/components/lmFormBuilderUi/LmUploadFilesBuilderUi'
import LmSignersBuilderUi from '@/components/lmFormBuilderUi/LmSignersBuilderUi'
import LmImportFromExcelBuilderUi from '@/components/lmFormBuilderUi/LmImportFromExcelBuilderUi'
import LmCustomBuilderUi from '@/components/lmFormBuilderUi/LmCustomBuilderUi'
import LmRadioBuilderUi from '@/components/lmFormBuilderUi/LmRadioBuilderUi'
import LmCodeInputBuilderUi from '@/components/lmFormBuilderUi/LmCodeInputBuilderUi'
import LmTreeSelectBuilderUi from '@/components/lmFormBuilderUi/LmTreeSelectBuilderUi'
import LmEditorBuilderUi from '@/components/lmFormBuilderUi/LmEditorBuilderUi'
import LmTagsInputBuilderUi from '@/components/lmFormBuilderUi/LmTagsInputBuilderUi'
import draggable from 'vuedraggable'
import LmFormBuilder from '@/components/LmFormBuilder'

// Utils
import commonsApi from '@/api/commons'
import lmToasts from '@/mixins/lmToasts.js'
import lmFormBuilderUi from '@/mixins/lmFormBuilderUi.js'
import { required } from 'vuelidate/lib/validators'

export default {
  mixins: [lmToasts, lmFormBuilderUi],
  provide () {
    const context = {}
    for (const key in this.form) {
      Object.defineProperty(context, key, {
        enumerable: true,
        get: () => this.form[key]
      })
    }
    return { context }
  },
  components: {
    LmForm,
    LmButton,
    LmTextInput,
    LmTextArea,
    LmEmailInput,
    LmTreeSelect,
    LmRadio,
    LmCheckbox,
    LmSelect,
    LmSuperPowerSelectV2,
    LmTextNumberEditorTextAreaPasswordBuilderUi,
    LmEmailInputBuilderUi,
    LmFormSubtitlesBuilderUi,
    LmFormEmptySpaceBuilderUi,
    LmFormSeparatorBuilderUi,
    LmSelectBuilderUi,
    LmSuperPowerSelectV2BuilderUi,
    LmButtonBuilderUi,
    LmDateBuilderUi,
    LmDateTimeBuilderUi,
    LmLeaFletMapBuilderUi,
    LmHtmlContentBuilderUi,
    LmFormPortalBuilderUi,
    LmColorPickerBuilderUi,
    LmCommentBuilderUi,
    LmRepeatFieldsBuilderUi,
    LmCheckboxBuilderUi,
    LmUploadFilesBuilderUi,
    LmSignersBuilderUi,
    LmImportFromExcelBuilderUi,
    LmCustomBuilderUi,
    LmRadioBuilderUi,
    LmCodeInputBuilderUi,
    LmTreeSelectBuilderUi,
    LmEditorBuilderUi,
    LmTagsInputBuilderUi,
    draggable,
    LmFormBuilder
  },
  props: {
    isOnEditMode: {
      type: Boolean,
      default: false
    },
    pathToRedirectOnCancel: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      deleted: false,
      formData: {
        typeName: '',
        typeAlias: '',
        typeDescription: '',
        idType: [],
        published: false,
        instancePrivileges: {
          area: [],
          subarea: [],
          role: []
        }
      },
      form: {
        validations: {},
        formElements: [],
        lumbreInternal: true
      },
      isLoading: false,
      modes: {
        selected: 'edit',
        editView: true
      },
      peopleTypesOptionsForDuplicate: [],
      componentsOptions: {
        content: []
      }
    }
  },
  validations: {
    formData: {
      typeName: {
        required
      },
      typeAlias: {
        required
      },
      typeDescription: {
        required
      },
      idType: {
        required
      }
    }
  },
  methods: {
    async loadFormElements (event) {
      try {
        if (Array.isArray(event) && !event.length) {
          this.form.formElements = []
        } else {
          const peopletype = await commonsApi.axiosGetWrapper(`peopletypes/${event.id}`)
          const fields = peopletype.data.peopleFields
          this.form.formElements = fields
        }
      } catch (error) {
        console.log(error)
      }
    },
    title (component) {
      if (this.componentsOptions?.content?.length) {
        const componentLabel = component?.componentProps?.label
        const componentValue = component?.componentProps?.value
        const componentText = component?.componentProps?.text
        const { text } = this.componentsOptions.content.find(e => e.value === component?.componentName)
        let moreInfo = ''
        if (componentLabel) {
          moreInfo += ' - ' + componentLabel
        } else if (componentValue) {
          moreInfo += ' - ' + componentValue
        } else if (componentText) {
          moreInfo += ' - ' + componentText
        }
        return text + moreInfo
      } else {
        return ''
      }
    },
    shouldCreatePortal (componentName) {
      return componentName !== 'LmComment'
    },
    openEditFormElement (index) {
      this.$root.$emit('bv::toggle::collapse', `collapse-${index}`)
    },
    addFormElement (elementIndex) {
      this.selectorElementForm('LmTextInput', elementIndex)
    },
    leftValueToCompareOptions (formElementToExclude) {
      return {
        disabledOption: this.$t('Element'),
        content: this.form.formElements.filter(e => e.hasOwnProperty('formObjectToSendToServerProperty')).filter(e => e.id !== formElementToExclude.id).map(e => ({ value: e.formObjectToSendToServerProperty, text: e.componentProps.label }))
      }
    },
    validationsChangesHandler (payload) {
      let newValidation = {}
      const formValidationHasItem = Object.keys(this.form.validations).length
      if (formValidationHasItem) {
        for (const validation in this.form.validations) {
          const existFormObjectToSendToServerPropertyForValidation = this.form.formElements.find((el) => el.formObjectToSendToServerProperty === validation)
          if (existFormObjectToSendToServerPropertyForValidation) {
            newValidation = { ...newValidation, [validation]: this.form.validations[validation] }
          }
        }
        this.form.validations = { ...newValidation, ...payload }
      } else {
        this.form.validations = { ...this.form.validations, ...payload }
      }
    },
    inputHandler (event, index) {
      this.form.formElements[index] = event
    },
    async onSubmit () {
      try {
        this.isLoading = true
        const peopletypeData = {
          ...this.formData,
          peopleFields: [...this.form.formElements],
          peopleFieldsValidations: this.form.validations
        }
        // Validaciones
        await this.validationForm(this.$v, false, this.formData)

        if (!this.isOnEditMode) {
          // Nuevo
          await commonsApi.axiosPostWrapper('/peopletypes/', peopletypeData)
          this.lmToastSuccessMessage(`Se creó el tipo de persona correctamente.`, 'Se guardó exitosamente')
        } else {
          // Editar
          await commonsApi.axiosPutWrapper(`/peopletypes/${this.$route?.params?.id}`, peopletypeData)
          this.lmToastSuccessMessage(`Se editó el tipo de persona correctamente.`, 'Se guardó exitosamente')
        }

        setTimeout(() => {
          this.$router.push(this.pathToRedirectOnCancel)
        }, 650)
      } catch (error) {
        this.lmToastDangerMessage(error.message, 'Error')
      } finally {
        this.isLoading = false
      }
    },
    onCancel () {
      this.$router.push(this.pathToRedirectOnCancel)
    },
    validationForm (validation, mustShowToast = true, formData) {
      if (!formData.typeName) {
        return Promise.reject(new Error('El campo Nombre es obligatorio'))
      }
      if (!formData.typeAlias) {
        return Promise.reject(new Error('El campo Alias es obligatorio'))
      }
      if (!formData.typeDescription) {
        return Promise.reject(new Error('El campo Descripción es obligatorio'))
      }
      if (!formData.idType) {
        return Promise.reject(new Error('El campo Tipo de Identificador es obligatorio'))
      }
      validation.$touch()
      if (validation.$error) {
        if (mustShowToast) {
          this.showToastFormError()
        }
        return Promise.reject(new Error('Todos los campos son obligatorios'))
      } else {
        if (!validation.$pending || !validation.$error) {
          return Promise.resolve(true)
        } else {
          Promise.reject(new Error('Todos los campos son obligatorios'))
        }
      }
    },
    async onDelete () {
      try {
        this.isLoading = true

        await commonsApi.axiosPutWrapper(`/peopletypes/delete/${this.$route?.params?.id}`)
        this.lmToastSuccessMessage(`Se eliminó el tipo de persona correctamente.`, 'Se eliminó correctamente')

        setTimeout(() => {
          this.$router.push(this.pathToRedirectOnCancel)
        }, 650)
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    async onPublish () {
      try {
        this.isLoading = true
        const peopletypeData = {
          ...this.formData,
          peopleFields: [...this.form.formElements],
          peopleFieldsValidations: this.form.validations
        }

        await commonsApi.axiosPutWrapper(`/peopletypes/publish/${this.$route?.params?.id}`, peopletypeData)
        this.lmToastSuccessMessage(`Se publicó el tipo de persona correctamente.`, 'Se publicó correctamente')

        setTimeout(() => {
          this.$router.push(this.pathToRedirectOnCancel)
        }, 650)
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    async onUnpublish () {
      try {
        this.isLoading = true

        await commonsApi.axiosPutWrapper(`/peopletypes/unpublish/${this.$route?.params?.id}`)
        this.lmToastSuccessMessage(`Se despublicó el tipo de persona correctamente.`, 'Se despublicó correctamente')

        setTimeout(() => {
          this.$router.push(this.pathToRedirectOnCancel)
        }, 650)
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    }
  },
  async created () {
    if (this.isOnEditMode) {
      const { data } = await commonsApi.axiosGetWrapper(`peopletypes/${this.$route.params.id}`)
      // Cargo las propiedades en modo edición
      for (const key in this.formData) {
        if (data.hasOwnProperty(key)) {
          this.formData[key] = data[key]
        }
      }
      this.form.formElements = data?.peopleFields || []
      this.form.validations = data?.peopleFieldsValidations || {}
    }
  },
  async mounted () {
    // Opciones para duplicar tipos de trámite
    const peopleTypes = await commonsApi.axiosGetWrapper('/peopletypes/?pageSize=100')
    const options = peopleTypes.data.rows.filter(people => people._id !== this.$route?.params?.id).map(person => {
      return {
        id: person._id,
        name: person.typeName
      }
    })
    this.peopleTypesOptionsForDuplicate = options
  }
}

</script>

<style>
/* .button {
  margin-top: 35px;
} */
</style>
